import { render, staticRenderFns } from "./priceUpscaler.vue?vue&type=template&id=5c6b6b9a&scoped=true"
import script from "./priceUpscaler.vue?vue&type=script&lang=js"
export * from "./priceUpscaler.vue?vue&type=script&lang=js"
import style0 from "./priceUpscaler.vue?vue&type=style&index=0&id=5c6b6b9a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b6b9a",
  null
  
)

export default component.exports